import * as React from 'react';

import { cn } from '@/lib/utils';

const cardBaseClass =
	'bg-card text-card-foreground flex flex-col gap-6 py-6 px-4';
const cardHeaderBaseClass =
	'@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6';
const cardTitleBaseClass = 'leading-none font-semibold';
const cardDescriptionBaseClass = 'text-muted-foreground text-sm';
const cardActionBaseClass =
	'col-start-2 row-span-2 row-start-1 self-start justify-self-end';
const cardContentBaseClass = 'px-6';
const cardFooterBaseClass = 'flex items-center px-6 [.border-t]:pt-6';

function Card({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card"
			className={cn(cardBaseClass, className)}
			{...props}
		/>
	);
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card-header"
			className={cn(cardHeaderBaseClass, className)}
			{...props}
		/>
	);
}

function CardTitle({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card-title"
			className={cn(cardTitleBaseClass, className)}
			{...props}
		/>
	);
}

function CardDescription({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card-description"
			className={cn(cardDescriptionBaseClass, className)}
			{...props}
		/>
	);
}

function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card-action"
			className={cn(cardActionBaseClass, className)}
			{...props}
		/>
	);
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card-content"
			className={cn(cardContentBaseClass, className)}
			{...props}
		/>
	);
}

function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot="card-footer"
			className={cn(cardFooterBaseClass, className)}
			{...props}
		/>
	);
}

export {
	Card,
	CardAction,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
	cardActionBaseClass,
	cardBaseClass,
	cardContentBaseClass,
	cardDescriptionBaseClass,
	cardFooterBaseClass,
	cardHeaderBaseClass,
	cardTitleBaseClass
};
